module.exports = __webpack_public_path__ + "static/media/p_31_2.c55dd912.png";